import React, { useEffect, useState } from 'react'
// import ProgramManagerPartnerGrid from './DreamBigProgramManagerPartnerGrid'
import DreamBigProgramManagerPartnerGrid from './DreamBigProgramManagerPartnerGrid'
import Select, { components } from "react-select";
import { toast } from "react-toastify";
// import ProgramManagerProgramGrid from './DreamBigProgramManagerProgramGrid';
import DreamBigProgramManagerProgramGrid from "./DreamBigProgramManagerProgramGrid"
import api from '../../utils/api';
import DreamBigProgramManagerEntryPointGrid from './DreamBigProgramManagerEntryPointGrid';

const DreamBigProgramManagerHome = (props) => {

    const [programManagerList, setProgramManagerList] = useState([])
    const [shouldOpen, setShouldOpen] = React.useState(true);
    const SELECT_ALL_OPTION = { label: "Select All", value: "__all__" };

    useEffect(() => {
        const {tempProgramManagerListDreamBigUser} = api.getProgramManagerListDreamBigUser()
        .then(({data}) => {
            console.log("List", data)
            const options = data
                .filter(item => item.sProgramManager !== "" && item.sProgramManager !== null) 
                .map(item => ({
                    label: item.sProgramManager,  
                    value: item.sProgramManager, 
                }));
                setProgramManagerList(options)
        })
    }, [])


    const onProgramManagerChange = (option) => {
        console.log("opt", option)
        props.setSelectedsEntryPoint([]);
        props.setSelectedProgramManager(option)
        if(option){
            props.getProgramManagerData(option)
            props.getProgramDataforManager(option)
            props.getEntryPoints(option)
        } else {
            props.setPartnerDataProgramManager([])
            props.setProgramDataManager([])
        }
    }

    const Option = (props) => {
        const { data, selectProps } = props;
    
        const isSelectAll = data.value === "__all__";
        const allOptions = selectProps.options.filter(opt => opt.value !== "__all__");
        const selected = selectProps.value || [];
    
        const isAllSelected = allOptions.length > 0 && selected.length === allOptions.length;
    
        const isChecked = isSelectAll ? isAllSelected : props.isSelected;
    
        return (
          <components.Option {...props}>
            <input
              type="checkbox"
              checked={isChecked}
              onChange={() => null}
              style={{ marginRight: 8, zIndex: 1000}}
            />
            {props.label}
          </components.Option>
        );
      };
    
    
      const customStyles = {
        option: (provided, state) => ({
          ...provided,
          backgroundColor: state.isSelected ? "#e6f7ff" : "white",
          color: "black",
        }),
        menuPortal: (base) => ({
          ...base,
          zIndex: 9999, // Makes sure it's on top
        }),
        menu: (base) => ({
          ...base,
          zIndex: 9999,
        }),
      };
    
    
    
      const handleMenuOpen = () => {
        if (!props.selectedProgramManager || props.selectedProgramManager.length == 0) {
          toast("Please select Program Manager", {
            type: toast.TYPE.ERROR,
          });
          setShouldOpen(false);
        } else {
          setShouldOpen(true);
        }
      };

      const onEntryPointChange = (selectedOptions) => {
        if (!selectedOptions) {
          props.setSelectedsEntryPoint([]);
          return;
        }
      
        const isSelectAllSelected = selectedOptions.some(
          (option) => option.value === SELECT_ALL_OPTION.value
        );
      
        if (isSelectAllSelected) {
          const isCurrentlyAllSelected =
            props.selectedsEntryPoint.length === props.entryPointList.length;
      
          if (isCurrentlyAllSelected) {
            props.setSelectedsEntryPoint([]);
            return;
          }
      
          props.setSelectedsEntryPoint(props.entryPointList);
          props.getFTCDataByPM(props.entryPointList);
          return;
        }
      
        props.setSelectedsEntryPoint(selectedOptions);
        props.getFTCDataByPM(selectedOptions);
      };
      
    
  return (
    <div>
<h3
      className="spled-black-text"
      style={{
        fontSize: "25px",
        marginRight: 10,
        textAlign: 'center',
        // margin: 10
      }}
    >
      Program Manager Dashboard
    </h3>
         <div className="row mt-4 mb-4">
        <div className="col-md-6">
          <Select
            options={programManagerList}
            onChange={onProgramManagerChange}
            value={props.selectedProgramManager}
            styles={customStyles}
            placeholder="Select Program Manager"
            isClearable
          />
        </div>
        <div className="col-md-6">

          <Select
            options={
              props.entryPointList && props.entryPointList.length > 0
                ? [SELECT_ALL_OPTION, ...props.entryPointList]
                : []
            }
            onChange={onEntryPointChange}
            value={props.selectedsEntryPoint}
            placeholder="Select Partner (Entry Point)"
            isMulti
            isClearable
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            components={{ Option }}
            styles={customStyles}
            onMenuOpen={handleMenuOpen}
            menuIsOpen={shouldOpen ? undefined : false}
          />
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <DreamBigProgramManagerEntryPointGrid
            fromDate={props.fromDate}
            toDate={props.toDate}
            resourceDataSelectedPartner={props.resourceDataSelectedPartner}
            selectedPartnerName={props.selectedPartnerName}
            setSelectedPartnerName={props.setSelectedPartnerName}
            getResourceDataForSelectedPartner={props.getResourceDataForSelectedPartner}
            partnerDataProgramManager={props.partnerDataProgramManager}
            getProgramManagerData={props.getProgramManagerData}
            setResourceDataSelectedPartner={props.setResourceDataSelectedPartner}
            selectedProgramManager={props.selectedProgramManager}
            pmData={props.pmData}
            selectedsEntryPoint={props.selectedsEntryPoint}
            isClearClicked={props.isClearClicked}
            clearRef={props.clearRef}
            searchRef={props.searchRef}
          />

        </div>
      </div>
    </div>
  )
}

export default DreamBigProgramManagerHome
